import React from 'react';
import {
  Button,
  HStack,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  useDisclosure,
} from '@chakra-ui/react';

interface DeleteConfirmationProps {
  message?: string;
  onConfirm: () => void;
  trigger: React.ReactElement; // e.g. <CustomButton>Delete</CustomButton>
}

export const DeleteConfirmation: React.FC<DeleteConfirmationProps> = ({
  message = 'Are you sure you want to delete?',
  onConfirm,
  trigger,
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  // clone the trigger button so we can inject onClick
  return (
    <>
      {React.cloneElement(trigger, {
        onClick: onOpen,
      })}

      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Confirm Deletion</ModalHeader>
          <ModalBody>
            <Text>{message}</Text>
          </ModalBody>
          <ModalFooter>
            <HStack>
              <Button colorScheme="red" onClick={handleConfirm}>
                Yes
              </Button>
              <Button variant="outline" onClick={onClose}>
                No
              </Button>
            </HStack>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

// export default DeleteConfirmation;
